import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {ContentInfo} from '../model/content-info';

@Injectable()
export class ContentService {

  constructor(private httpClient: HttpClient) { }


  public upload(content: FormData) : Observable<ContentInfo> {
    return this.httpClient.post<ContentInfo>('/api/content', content);
  }

  public list(type: string) : Observable<ContentInfo[]> {
    return this.httpClient.get<ContentInfo[]>('/api/content?type=' + type);
  }

  public uri(id : string) : string {
    return '/api/content/' + id;
  }

  public delete(id : string) : Observable<any> {
    return this.httpClient.delete('/api/content/' + id);
  }
}



// WEBPACK FOOTER //
// /home/developer/Downloads/SleepRestoreBackend/sleep-restore-boot/src/main/ngapp/src/app/service/content.service.ts